module.exports = __webpack_public_path__ + "static/img/noCoupon.3010521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/default_images/noCoupon.png
// module id = Cu3C
// module chunks = 91